"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Snackbar = require("./Snackbar.styles");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Snackbar = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var icon = _ref.icon,
    keyId = _ref.keyId,
    message = _ref.message,
    title = _ref.title,
    type = _ref.type,
    closeSnackbar = _ref.closeSnackbar;
  var _type = type === 'error' ? 'warning' : type; // Error should have warning color
  var classes = (0, _Snackbar.useStyles)({
    type: _type
  });
  var closeHandler = (0, _react.useCallback)(function () {
    typeof closeSnackbar === 'function' && closeSnackbar(keyId);
  }, [keyId, closeSnackbar]);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.root,
    "data-testid": keyId
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.iconWrapper
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: icon
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.header
  }, title && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.title
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.message
  }, message)), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.close,
    onClick: closeHandler
  }, "\xD7")));
});
exports.Snackbar = Snackbar;